(function () {
  new Vue({
    el: '[data-vue=FooterPages]',
    data: {
      getReputation: '',
      showReputation: false
    },
    methods: {
      loadScript () {
        return new Promise(function (resolve, reject) {
          const injectScript = document.createElement('script');
          let status = false;
          injectScript.type = 'text/javascript';
          injectScript.src = 'https://s3.amazonaws.com/raichu-beta/ra-verified/bundle.js';
          injectScript.async = true;
          injectScript.id = 'ra-embed-verified-seal';
          injectScript.setAttribute('data-target', 'ra-verified-seal');
          injectScript.setAttribute('data-model', '2');
          injectScript.setAttribute('data-id', 'SmJMUVpDa29sbjhtbkFUdDptZWdhLWxvdGVyaWFz');
          injectScript.onerror = function (err) {
            reject(err, injectScript);
          };
          injectScript.onload = injectScript.onreadystatechange = function () {
            if (!status && (!this.readyState || this.readyState == 'complete')) {
              status = true;
              resolve();
            }
          };
          document.body.appendChild(injectScript);
        });
      },
      getImage () {
        const image = document.getElementsByClassName('ra-widget-reputation-stamp');
        const imageText = document.getElementsByClassName('ra-widget-reputation-logo');

        if (image.length > 0) {
          const imageReputation = image[0];
          imageReputation.setAttribute('width', '38');
          imageReputation.setAttribute('height', '38');
          imageReputation.setAttribute('loading', 'lazy');
        }
        if (imageText.length > 0) {
          const imageReputationText = imageText[0];
          imageReputationText.setAttribute('loading', 'lazy');
        }
      },
      getReputationData () {
        const valueText = document.getElementsByClassName('ra-widget-reputation-text');
        if (valueText.length > 0) {
          const textReputation = valueText.item(0);
          this.getReputation = textReputation.innerText.toLowerCase();
          if (this.getReputation === 'ruim' || this.getReputation === 'regular') {
            this.showReputation = true;
          }
        }
      }
    },
    created: async function () {
      await this.loadScript();
      setTimeout(() => {
        this.getImage();
        this.getReputationData();
      }, 700);
    }
  });
})();
